import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  
  .sidebar{
    width: 210px;
    bottom: 0;
    background-color: #fff;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    
  }

  .panel{
    width: 100%;
    margin-left: 15px;
  }

  .top-logo{

    display: flex;
    justify-content: center;
    padding: 60px 0 22px 0;
    img{
      width: 75px;
    }
  }


  .nav-item{
    display: flex;
    align-items: center;
    height: 40px;
    width: 170px;
    margin: 6px 12px;
    padding: 9px 18px;
    border-radius: 12px;
    text-decoration: none;
    color: var(--black-color);

    cursor: pointer;

    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;

    img{
      margin: 0 6px;
      width: 18px;
    }

    position: relative;

    /* Selo de pedidos pendentes. É <b>, não <span>, porque no menu estreito os
       <span> do item (o rótulo) são escondidos e o selo tem de continuar. */
    .badge{
      margin-left: auto;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      border-radius: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #C43333;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      line-height: 1;
    }
  }

  .active, .nav-item:hover {
    background-color: var(--primary-color);
    color: #fff;

    font-weight: normal;
    
    img{
        filter: invert(100%) brightness(150%);
    }
  }

  /* ---- Menu recolhível ----
     O estado vem da classe .colapsado (hook useMenuColapsavel): padrão
     recolhido em tela estreita, preferência do usuário depois disso. */
  .sidebar{
    position: relative;
    flex-shrink: 0;
    transition: width .2s ease;
  }

  .toggle-menu{
    position: absolute;
    top: 14px;
    right: -12px;
    z-index: 2;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 1px solid #E1E3E6;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0,0,0,.18);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img{ width: 6px; height: 12px; }

    &:hover{ background: var(--primary-color); img{ filter: invert(100%) brightness(150%); } }
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
  }

  .sidebar.colapsado{
    width: 60px;

    .top-logo{
      img{ width: 45px; }
    }

    .nav-item{
      margin-left: 0;
      width: 60px;
      justify-content: center;
      span{ display: none; }

      .badge{
        position: absolute;
        top: 2px;
        right: 4px;
        margin: 0;
      }
    }
  }

  .sidebar.colapsado + .panel{
    margin-left: 18px;
  }

  @media (prefers-reduced-motion: reduce){
    .sidebar{ transition: none; }
  }

`
